module.exports = __webpack_public_path__ + "img/Plate glass.8fa9d819.svg";